import OrganisationIndexGroupMapper from "../../organisations/service/OrganisationIndexGroupMapper";
import { formatBooleanValue } from "../../util";
import IndexTypeGroup from "../model/IndexTypeGroup";
import IndexTypeMapper from "./IndexTypeMapper";

const IndexTypeGroupMapper = (item: any) => {
  let indexTypeGroup = IndexTypeGroup(item);
  indexTypeGroup.valid = formatBooleanValue(item.valid);
  indexTypeGroup.childGroups = (item.childGroups || []).map(
    IndexTypeGroupMapper
  );
  indexTypeGroup.items = (item.items || []).map(IndexTypeMapper);
  indexTypeGroup.organisationIndexGroupList = (
    item.organisationIndexGroupList || []
  ).map(OrganisationIndexGroupMapper);
  var childIds = item.childIds?.split(";");
  var indexTypeIds = item.indexTypeIds?.split(";");
  indexTypeGroup.childIds = childIds?.map((elem) => Number(elem));
  indexTypeGroup.indexTypeIds = indexTypeIds?.map((elem) => Number(elem));
  return indexTypeGroup;
};

export default IndexTypeGroupMapper;
